import {useState} from "react";
import {useParams, useNavigate} from "react-router-dom"
import BatterIconLogo from "./BatterIconLogo";
import "../styles/passwordResetForm.css"

function PasswordResetForm() {
    const {token} = useParams()
    //console.log('token', token)
    const navigate = useNavigate()
    const [password, setPassword] = useState('')
    const [email, setEmail] = useState('')
    const [passwordConfirmation, setPasswordConfirmation] = useState('')
    const [errorsState, setErrorsState] = useState([])
    const [pwStatus, setPWStatus] = useState(false)

    function handleSubmit(e) {
        e.preventDefault()
        fetch(`/api_password_resets/${token}`, {
            method: "PATCH",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                email: email,
                password: password,
                password_confirmation: passwordConfirmation,
                token: token
            })
        })
        .then(res => res.json())
        .then(data => {
            //console.log('data on password reset form', data)
            if (!data.error) {
                setPWStatus(true)
            }
            else {
                setPassword("")
                setPasswordConfirmation("")
                const errors = <li className="errors">{data.error}</li>
                setErrorsState(errors)
                //console.log('errorsState', errorsState)
            }
        })
    }

    function navigateToLogin() {
        navigate('/login')
        window.scrollTo(0, 0)
    }

    return (
        <div className="resetPWFormContainer">
            {/* <BatterIconLogo logoID={"pw-reset-logo"} /> */}
            <div className="resetPWFormElements">
                <h2>Reset Your Password Here</h2>
                <form onSubmit={handleSubmit}>
                    <label>Email:</label>
                    <br />
                    <input type="text" value={email} placeholder="Enter Email Address" onChange={(e) => setEmail(e.target.value)} />
                    <br />
                    <label>New Password:</label>
                    <br />
                    <input type="password" value={password} placeholder="Enter New Password" onChange={(e) => setPassword(e.target.value)} />
                    <br />
                    <label>Confirm New Password:</label>
                    <br />
                    <input type="password" value={passwordConfirmation} placeholder="Enter New Password Again" onChange={(e) => setPasswordConfirmation(e.target.value)} />
                    <br />
                    <button type="submit">Submit</button>
                </form>
                {pwStatus && (
                    <div>
                        <h2>Password Reset. Please Login.</h2>
                        <button onClick={navigateToLogin}>Login</button>
                    </div>
                )}
                {errorsState.length > 0 && ({errorsState})}
            </div>
        </div>
    )
}

export default PasswordResetForm